import { Tab, Tabs } from '@mui/material';
import { ReactElement, useCallback, useMemo } from 'react';

import { Category, CategoryName } from '@app/types/catalog';

const tabs = [
  { label: 'スポット求人を探す', value: CategoryName.SPOT },
  { label: '定期非常勤を探す', value: CategoryName.PART_TIME },
] as const;

interface SearchTypeTabProps {
  items: Category[];
  onChangeTab: (selectedTab: string) => void;
  value?: string | null;
}

export function SearchTypeTab({
  items,
  onChangeTab,
  value,
}: SearchTypeTabProps): ReactElement {
  const selected = useMemo(() => {
    if (tabs.some((t) => t.value === value)) {
      return value;
    }
    return tabs[0].value;
  }, [value]);

  const handleChange = useCallback(
    (event: React.SyntheticEvent, selectedTab: string) => {
      onChangeTab(selectedTab);
    },
    [onChangeTab]
  );

  return (
    <Tabs value={selected} onChange={handleChange} variant="fullWidth">
      {tabs.map(({ label, value }, index) => (
        <Tab key={index} label={label} value={value} />
      ))}
    </Tabs>
  );
}
